import { forwardRef, TextareaHTMLAttributes } from 'react';
import { foundationSemantic } from '../../foundation';
import { cx } from './utils';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid = false, className, ...props },
  ref
) {
  return (
    <textarea
      ref={ref}
      className={cx(
        'w-full border text-sm',
        foundationSemantic.input.base,
        foundationSemantic.input.textarea,
        foundationSemantic.input.surface,
        foundationSemantic.input.border,
        foundationSemantic.input.text,
        foundationSemantic.input.placeholder,
        invalid && foundationSemantic.input.invalid,
        className
      )}
      aria-invalid={invalid || undefined}
      {...props}
    />
  );
});

export default Textarea;
export type { TextareaProps };
